<div class="title-box {{ titleSectionProp.class }}">
    <h2 class="{{ titleSectionProp.titleClass }}" *ngIf="titleSectionProp.title">{{ titleSectionProp.title }}</h2>
    <p class="{{ titleSectionProp.descClass }}" *ngIf="titleSectionProp.description">{{ titleSectionProp.description }}</p>
</div>